import React from 'react';
import { Card, Typography, Grid } from '@mui/material';
import { t } from 'i18next';
import { Spacer } from '../';

export interface CarouselCardConfig {
  configKey: string;
  icon: React.ReactNode;
  text: string | React.ReactNode;
  className?: string;
}

export const CarouselCard: React.FC<CarouselCardConfig> = ({
  configKey,
  icon,
  text,
  className,
}) => {
  return (
    <Card key={configKey} className={className}>
      <Grid>{icon}</Grid>

      <Spacer height='xxxs' />

      {typeof text === 'string' ? (
        <Typography variant='p14' color='secondary' textAlign='center'>
          {t(text)}
        </Typography>
      ) : (
        text
      )}
    </Card>
  );
};
